import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  DOCUMENT,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BsportalstorageService } from '@app_services/bsportalstorage.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';
import { ThemeServiceService } from './theme-service.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private document = inject<Document>(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private bsportalstorageService = inject(BsportalstorageService);
  private themeServiceService = inject(ThemeServiceService);
  private messageService = inject(MessageService);

  title = 'bsportal';
  public subscription?: Subscription;

  ngOnInit() {
    if (location.href.includes('res=')) {
      const hash = window.location.hash; // e.g. "#/?res=<encoded>"
      const queryString = hash.includes('?')
        ? hash.substring(hash.indexOf('?'))
        : window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const base64String = urlParams.get('res');
      if (base64String) {
        const decodedBase64 = atob(decodeURIComponent(base64String));
        const decodedJson = JSON.parse(decodedBase64);
        sessionStorage.setItem('BS_LOGIN_DETAILS', JSON.stringify(decodedJson));
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      // let environment: EnvironmentEnum = 'DEV';
      // if (
      //   !this.document.location.host ||
      //   this.document.location.host.indexOf('localhost') > -1 ||
      //   this.document.location.host.indexOf('127.0.0.1') > -1
      // ) {
      //   environment = 'DEV';
      // } else if (this.document.location.host.indexOf('stage') > -1) {
      //   environment = 'STAGE';
      // } else {
      //   environment = 'PROD';
      // }
      //
      // let brand: EnvironmentTheme = 'BACKSPACE';
      //
      // if (
      //   this.document.location.host &&
      //   this.document.location.host.indexOf('localhost') > -1
      // ) {
      //   // brand = 'BACKSPACE';
      // } else if (this.document.location.host.indexOf('backspace')) {
      //   brand = 'BACKSPACE';
      // } else if (this.document.location.host.indexOf('st-cloud')) {
      //   brand = 'STCLOUD';
      // } else if (this.document.location.host.indexOf('lanline')) {
      //   brand = 'LANLINE';
      // } else if (this.document.location.host.indexOf('yaxxa')) {
      //   brand = 'YAXXA';
      // // } else if (this.document.location.host.indexOf('ikhokha')) {
      // //   brand = 'IKHOKHA';
      // } else if (this.document.location.host.indexOf('klik')) {
      //   brand = 'KLIK';
      // // } else if (this.document.location.host.indexOf('mtn')) {
      // //   brand = 'MTN';
      // }
      this.themeServiceService.init();
      // this.applyTheme(environment);
      // switch (brand) {
      //   case 'BACKSPACE':
      //     this.replaceThemeHref('styling-backspace.css');
      //     break;
      //   case 'IKHOKHA':
      //     this.replaceThemeHref('styling-ikhokha.css');
      //     break;
      //   case 'KLIKPBX':
      //     this.replaceThemeHref('styling-klik.css');
      //     break;
      //   case 'LANLINE':
      //     this.replaceThemeHref('styling-lanline.css');
      //     break;
      //   case 'STCLOUD':
      //     this.replaceThemeHref('styling-stcloud.css');
      //     break;
      //   case 'YAXXA':
      //     this.replaceThemeHref('styling-yaxxa.css');
      //     break;
      // }

      // this.bsportalstorageService.putEnvironmentDetails({
      //   type: environment,
      //   brand: brand,
      // });
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
